import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

export interface IProps extends React.ComponentPropsWithoutRef<'p'> {
  color?: 'highlight' | 'notice' | 'warning'
  width?: number
  height?: number
}

export const LabelSquare = ({
  color,
  width,
  height,
  ...props
}: IProps): JSX.Element => {
  const statusClass = {
    [Style.label]: true,
    [Style.labelHighlight]: color === 'highlight',
    [Style.labelNotice]: color === 'notice',
    [Style.labelWarning]: color === 'warning',
  }
  return (
    <p
      {...props}
      style={{ width: width, height: height }}
      className={classNames(statusClass)}
    >
      {props.children}
    </p>
  )
}

export default LabelSquare
